import FJTextStyle from './FJTextStyle';
import FJShadow from './style/FJShadow';
import FJOutline from './style/FJOutline';

class FJTextStyleBorderAndShadow extends FJTextStyle {
    initStyles(props = {}) {
        let shadow = new FJShadow({
            ...props,
            color: '#DCDAA2',
            offset: 10,
            angle: 97,
            blur: 0,
            position: 'relative',
        });

        let textOutline = new FJOutline({
            ...props,
            width: 50,
            color: '#811310',
            position: 'absolute',
            widthRef: 1200,
        });

        this._styles = [shadow, textOutline];
    }

    fromJSON(data) {
        this._styles = [new FJShadow({}), new FJOutline({})];
        super.fromJSON(data);
    }

    /**
     * @description 得到需要进行设置的值
     * @returns {{offset: *, outlineColor: *, width: *, blur: *, opacity: *, shadowColor: *, direction: *}}
     */
    getAdjustInfo() {
        let outline = this._styles[1];
        let shadow = this._styles[0];
        return {
            color: [shadow.color, outline.color],
            width: outline.width,
            blur: shadow.blur,
            opacity: shadow.opacity,
            offset: shadow.offset,
            direction: shadow.angle,
        };
    }

    /**
     * @description 设置对应的属性值
     * @param info
     */
    setAdjustInfo(info) {
        info.color.forEach((color, index) => {
            if (color !== '') this._styles[index].color = color;
        });
        if (info.width !== '') {
            this._styles[1].width = info.width;
        }
        if (info.blur !== '') {
            this._styles[0].blur = info.blur;
        }
        if (info.offset !== '') {
            this._styles[0].offset = info.offset;
        }
        if (info.opacity !== '') {
            this._styles[0].opacity = info.opacity;
        }
        if (info.direction !== '') {
            this._styles[0].angle = info.direction;
        }
    }

    /**
     * 将style应用到
     * @param view
     * @param textData
     * @param options
     */
    addToView(view, textData, options) {
        if (!view) return;
        if (this._enableStyle) {
            this._baseStyle.addToView(view, textData, options);
            return;
        }

        this._styles.forEach((style, index) => {
            style.addToView(view, textData, { ...options, isAddToSupportLayer: index !== this._styles.length - 1 });
        });
    }
}

export default FJTextStyleBorderAndShadow;
